export default __webpack_public_path__ + "static/media/UiAddInactive.0948d997.svg";